<tt-page *ngIf="!!itemsListMetaTableDatas">
    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListMetaTableDatas"></tt-list>
</tt-page>
